// extracted by mini-css-extract-plugin
module.exports = {"tncContainer":"purify_index__tncContainer--1BeN9","tnc":"purify_index__tnc--2a6xh"};